export class IdGenerator {
  private id = 0

  incAndGet() {
    return this.id++
  }
}
